import React from 'react';
import { Link } from 'react-router-dom';
import { navigationConfig } from '../data/navigationData';

const NavLinks = ({ currentPage, variant, onLinkClick }) => {
  const { mainLinks } = navigationConfig;
  
  const isActive = (path, page) => {
    if (path === '/blog' && page === 'whats-new') return true;
    if (path === '/ourtalents' && page === 'ourtalents') return true;
    return path.slice(1) === page || (path === '/blog' && page === 'blog');
  };

  return (
    <>
      {mainLinks.map((link, index) => {
        const active = isActive(link.path, currentPage);
        return (
          <li key={index} className={variant === 'mobile' ? 'nav-itemm' : 'nav-item'}>
            <Link
              to={link.path}
              className={variant === 'mobile' ? 
                `nav-linkk ${active ? 'active' : ''}` :
                `nav-link ${active ? 'active' : ''}`
              }
              onClick={onLinkClick}
              aria-current={active ? 'page' : undefined}
            >
              {link.label}
            </Link>
          </li>
        );
      })}
    </>
  );
};

export default NavLinks;